(function () {
  var FIXED_FLAG = "productGalleryFixed";

  function isProductGallerySwiper(swiperEl) {
    if (!swiperEl) return false;
    // Only target carousels whose slides are the product image gallery.
    return !!swiperEl.querySelector(".swiper-slide .product-media, .swiper-wrapper .product-media");
  }

  function applyOneSlidePerView(swiperEl) {
    var swiper = swiperEl.swiper;
    if (!swiper || !swiper.params) return false;

    if (swiper.params.breakpoints) {
      Object.keys(swiper.params.breakpoints).forEach(function (bp) {
        var cfg = swiper.params.breakpoints[bp];
        if (!cfg) return;
        cfg.slidesPerView = 1;
        cfg.spaceBetween = 0;
        cfg.centeredSlides = false;
      });
    }

    swiper.params.slidesPerView = 1;
    swiper.params.spaceBetween = 0;
    swiper.params.centeredSlides = false;

    try {
      swiper.update();
    } catch (e) {}
    return true;
  }

  function tryFix(swiperEl, attemptsLeft) {
    if (!swiperEl || swiperEl.dataset[FIXED_FLAG] === "true") return;
    if (!isProductGallerySwiper(swiperEl)) return;

    if (swiperEl.swiper && applyOneSlidePerView(swiperEl)) {
      swiperEl.dataset[FIXED_FLAG] = "true";
      return;
    }

    if (attemptsLeft > 0) {
      setTimeout(function () { tryFix(swiperEl, attemptsLeft - 1); }, 150);
    }
  }

  function scan() {
    document.querySelectorAll(".swiper-container").forEach(function (swiperEl) {
      tryFix(swiperEl, 25);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scan);
  } else {
    scan();
  }
  requestAnimationFrame(scan);
  setTimeout(scan, 200);
  setTimeout(scan, 800);
  setTimeout(scan, 2000);

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      if (!added) continue;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.classList && node.classList.contains("swiper-container")) {
          tryFix(node, 25);
        }
        if (node.querySelectorAll) {
          node.querySelectorAll(".swiper-container").forEach(function (swiperEl) {
            tryFix(swiperEl, 25);
          });
        }
      }
    }
  });
  observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
